<template>
  <div class="alumn-detail">
    <back-current v-if="appVersion === 'dd'" :title="info.specialName"></back-current>
    <div class="alumn-top" v-if="info">
      <div
        class="cover"
        :style="{
          background: `url(${$isCdn(
            info.specialPic ? info.specialPic : require('./../../../assets/image/rec_1.png')
          )}) 0 0 / 100% 100%`
        }"
      ></div>
      <div class="alumn-top-content">
        <div class="title">{{ info.specialName }}</div>
        <div class="user">
          <img v-if="info.userFace" :src="$isCdn(info.userFace)" alt="" />
          <span>{{ info.userName }}</span>
          <span class="c">
            <i class="iconfont iconguankan"></i>
            <span>{{ info.visitCount }}</span>
          </span>
          <span class="c">
            <i class="iconfont iconpingxing1"></i>
            <span>{{ info.avgScore.toFixed(1) }}</span>
          </span>
        </div>
        <div @click="handleShowDesc" v-if="info.specialMask" class="desc van-multi-ellipsis--l2">
          <!-- <i class="iconfont icon-arrow-down more-btn"></i> -->
          {{ info.specialMask }}
        </div>
        <div v-else class="no-desc">暂无简介</div>
      </div>
    </div>
    <ul class="subject-list" v-if="$route.params.id == '1808782235432648704'">
      <li
        v-for="i in subjectList1"
        :key="i.id"
        :class="{active: i.id === pagination.subjectId}"
        @click="onChangeSubject(i.id)"
      >
        {{ i.name }}
      </li>
    </ul>
    <ul
      class="subject-list"
      v-if="$route.params.id == '1825365122785214464' || $route.params.id == '1945379928933400576'"
    >
      <li
        v-for="i in subjectList2"
        :key="i.id"
        :class="{active: i.id === pagination.subjectId}"
        @click="onChangeSubject(i.id)"
      >
        {{ i.name }}
      </li>
      <li style="visibility: hidden" v-for="i in pList" :key="i">占位</li>
    </ul>
    <ul class="subject-list" v-if="$route.params.id == '2089921110345777152'">
      <li
        v-for="i in subjectList3"
        :key="i.id"
        :class="{active: i.id === pagination.subjectId}"
        @click="onChangeSubject(i.id)"
      >
        {{ i.name }}
      </li>
      <li style="visibility: hidden" v-for="i in pList" :key="i">占位</li>
    </ul>
    <div class="alumn-list" id="alumnList">
      <van-list
        v-if="list.length > 0"
        :immediate-check="false"
        class="main-content"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <box v-for="item in list" :key="item.id" :online="item" :showDate="false" :isWenxuan="isWenxuan" />
      </van-list>
      <van-empty v-else description="暂无资源"></van-empty>
    </div>
    <!-- 简介 -->
    <van-action-sheet v-model="show" :overlay="false" :close-on-click-overlay="false">
      <div class="action-content" id="actionContent">
        <div class="action-title">
          <span>简介</span>
          <i @click="show = false" class="iconfont icon-close"></i>
        </div>
        <div class="action-desc" v-if="info">{{ info.specialMask }}</div>
      </div>
    </van-action-sheet>

    <van-dialog v-model="show2" confirmButtonColor="#007AFF" confirmButtonText="知道了">
      <div class="tips">
        <i class="iconfont iconyuanxingjinggao"></i>
        <div class="p1">该专区的内容不计学时，课时由各市州组织发放。</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {getAlumnById, getAlumnDataById} from '@/api'
import box from '@/views/discover/box'
import backCurrent from '@/components/back-current.vue'
export default {
  components: {
    box,
    backCurrent
  },
  data() {
    return {
      show: false,
      show2: false,
      info: null,
      list: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        subjectId: 0,
        specialId: this.$route.params.id
      },
      maxPageSize: 1,
      finished: false,
      loading: false,
      subjectList1: [
        {
          id: '431069969715957895',
          name: '语文'
        },
        {
          id: '431069969715957896',
          name: '数学'
        },
        {
          id: '447863590683285258',
          name: '英语'
        },
        {
          id: '447863590683285241',
          name: '思想政治'
        },
        {
          id: '451735800527327259',
          name: '历史'
        },
        {
          id: '431069969715957897',
          name: '地理'
        },
        {
          id: '431069969715957898',
          name: '生物'
        },
        {
          id: '447863590683285230',
          name: '物理'
        },
        {
          id: '451735800523136990',
          name: '化学'
        },
        {
          id: '452893464795944755',
          name: '音乐'
        },
        {
          id: '455167325335855094',
          name: '体育与健康'
        },
        {
          id: '465806789716350621',
          name: '美术'
        }
      ],
      subjectList2: [
        {
          id: '431069969715957895',
          name: '语文'
        },
        {
          id: '431069969715957896',
          name: '数学'
        },
        {
          id: '447863590683285258',
          name: '英语'
        },
        {
          id: '498946171151192154',
          name: '道德与法治'
        },
        {
          id: '451735800527327259',
          name: '历史'
        },
        {
          id: '431069969715957897',
          name: '地理'
        },
        {
          id: '447863590683285230',
          name: '物理'
        },
        {
          id: '451735800523136990',
          name: '化学'
        },
        {
          id: '431069969715957898',
          name: '生物'
        },
        {
          id: '452893464795944755',
          name: '音乐'
        },
        {
          id: '455167325335855094',
          name: '体育与健康'
        },
        {
          id: '465806789716350621',
          name: '美术'
        },
        {
          id: '459702838847738609',
          name: '科学'
        }
      ],
      subjectList3: [
        {
          id: '431069969715957895',
          name: '语文'
        },
        {
          id: '431069969715957896',
          name: '数学'
        },
        {
          id: '447863590683285258',
          name: '英语'
        },
        {
          id: '498946171151192154',
          name: '道德与法治'
        },
        {
          id: '451735800527327259',
          name: '历史'
        },
        {
          id: '431069969715957897',
          name: '地理'
        },
        {
          id: '452893464795944755',
          name: '音乐'
        },
        {
          id: '455167325335855094',
          name: '体育与健康'
        },
        {
          id: '465806789716350621',
          name: '美术'
        },
        {
          id: '459702838847738609',
          name: '科学'
        }
      ],
      pList: [1, 2],
      isWenxuan: 0
    }
  },
  mounted() {
    if (this.$route.params.id === '1808782235432648704') {
      this.show2 = true
      this.pagination.subjectId = this.subjectList1[0].id
    }
    if (this.$route.params.id === '1825365122785214464') {
      this.show2 = true
      this.pagination.subjectId = this.subjectList2[0].id
    }
    if (this.$route.params.id === '1945379928933400576') {
      this.show2 = false
      this.pagination.subjectId = this.subjectList2[0].id
    }
    if (this.$route.params.id === '2089921110345777152') {
      this.show2 = false
      this.pagination.subjectId = this.subjectList3[0].id
    }
    this.getInfo()
    this.getList()
  },
  methods: {
    onLoad() {
      if (this.pagination.pageNo >= this.maxPageSize) {
        this.finished = true
        return
      }
      this.pagination.pageNo += 1
      this.loading = true
      this.getList()
    },
    getInfo() {
      getAlumnById(this.$route.params.id).then(res => {
        if (res.code === 0) {
          this.info = res.data
          this.isWenxuan = res.data.type != null && res.data.type === 0 ? 1 : 0
        }
      })
    },
    onChangeSubject(id) {
      this.pagination.pageNo = 1
      this.pagination.subjectId = id
      this.loading = true
      this.list = []
      this.getList()
    },
    getList() {
      getAlumnDataById(this.pagination).then(res => {
        this.list = [...this.list, ...res.data]
        this.maxPageSize = Math.ceil(res.totalDatas / this.pagination.pageSize)
        this.loading = false
      })
    },
    handleShowDesc() {
      this.show = true
      this.$nextTick(() => {
        const alumnList = document.getElementById('alumnList')
        const actionContent = document.getElementById('actionContent')
        actionContent.style.height = alumnList.clientHeight + 'px'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alumn-detail {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.alumn-top {
  position: relative;
  .cover {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    filter: blur(7px);
    -webkit-filter: blur(7px);
    -moz-filter: blur(7px);
    -ms-filter: blur(7px);
    -o-filter: blur(7px);
  }
  .alumn-top-content {
    position: relative;
    z-index: 99;
    padding: 16px;
    padding-bottom: 32px;
    .title {
      color: #fff;
      font-size: 18px;
      font-weight: 700;
    }
    .user {
      color: #fff;
      font-size: 14px;
      margin-top: 16px;
      img {
        vertical-align: middle;
        margin-right: 8px;
        width: 28px;
        height: 28px;
        border-radius: 50%;
      }
      .c {
        line-height: 1;
        margin-left: 10px;
      }
      .c span {
        vertical-align: middle;
        margin-left: 4px;
      }
      .c i {
        vertical-align: middle;
      }
    }

    .no-desc {
      word-break: break-all;
      color: #fff;
      margin-top: 16px;
      font-size: 14px;
    }
    .desc {
      word-break: break-all;
      color: #fff;
      margin-top: 16px;
      font-size: 14px;
    }
    /* .desc {
      position: relative;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      .more-btn {
        float: right;
        clear: both;
        font-size: 12px;
      }
    }
    .desc::before {
      content: '';
      float: right;
      height: 20px;
    }
    .desc::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      background: #fff;
    } */
  }
}

.alumn-list {
  overflow-y: auto;
  position: relative;
  z-index: 999;
  margin-top: -16px;
  flex: 1;
  background: #f4f6f9;
  border-radius: 12px 12px 0px 0px;
  padding: 16px;
  &::-webkit-scrollbar {
    display: none;
  }
}
.main-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.action-content {
  padding: 12px 16px;
  .action-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 14px;
      font-weight: 500;
      color: #303133;
    }
    i {
      color: #909399;
      font-size: 14px;
    }
  }
  .action-desc {
    margin-top: 12px;
    color: #606266;
    word-break: break-all;
  }
}

.subject-list {
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 12px;
  margin-bottom: 36px;
  li {
    margin-bottom: 10px;
    flex: 0 0 23%;
    width: 23%;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #1a1a1a;
    background: #ededed;
    border-radius: 900px 900px 900px 900px;
    &.active {
      background: #d6e9ff;
      color: #007aff;
    }
  }
}
</style>
<style lang="scss">
.main-content {
  .van-list__loading,
  .van-list__finished-text {
    width: 100%;
  }
}

.tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  i {
    margin: 20px 0;
    font-size: 42px;
    color: #ffaa00;
  }
  .p1 {
    margin-bottom: 24px;
    width: 80%;
    font-weight: 500;
    font-size: 15px;
    color: #1a1a1a;
    line-height: 24px;
    text-align: center;
  }
}
</style>
